(function () {
  var bar = document.querySelector('[data-coature-sticky-bar]');
  if (!bar || typeof IntersectionObserver === 'undefined') return;

  var sectionId = bar.dataset.sectionId;
  var productInfo = bar.closest('product-info');
  var hasBeenVisible = false;
  var observedButton = null;

  function primaryButton() {
    return document.getElementById('ProductSubmitButton-' + sectionId);
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) hasBeenVisible = true;
        currentBar().hidden = !hasBeenVisible || entry.isIntersecting;
      });
    },
    { rootMargin: '0px' }
  );

  // Dawn can replace the whole <product-info> contents (product swap), so the bar and the
  // primary button are always re-queried rather than held as fixed references.
  function currentBar() {
    return document.querySelector('[data-coature-sticky-bar]') || bar;
  }

  function watchPrimaryButton() {
    var button = primaryButton();
    if (!button || button === observedButton) return;
    if (observedButton) observer.unobserve(observedButton);
    observedButton = button;
    observer.observe(button);
  }

  // Mirror the primary button (disabled state + label, e.g. "Sold out" after a size change)
  // and the price, which Dawn re-renders on variant change via product-info.js.
  function sync() {
    var stickyBar = currentBar();
    var button = primaryButton();
    var stickyButton = stickyBar.querySelector('[data-coature-sticky-submit]');
    if (!button || !stickyButton) return;

    var disabled = button.hasAttribute('disabled');
    if (stickyButton.hasAttribute('disabled') !== disabled) stickyButton.toggleAttribute('disabled', disabled);

    var label = button.querySelector('span');
    var stickyLabel = stickyBar.querySelector('[data-coature-sticky-label]');
    if (label && stickyLabel && stickyLabel.textContent.trim() !== label.textContent.trim()) {
      stickyLabel.textContent = label.textContent.trim();
    }

    var price = document.getElementById('price-' + sectionId);
    var stickyPrice = stickyBar.querySelector('[data-coature-sticky-price]');
    if (price && stickyPrice) {
      var html = price.innerHTML.replace(/\bprice--large\b/g, '');
      // Compare with what was last written, not stickyPrice.innerHTML: the browser re-serialises
      // innerHTML, so that comparison could never settle and would re-trigger the observer.
      if (stickyPrice.coatureSourceHtml !== html) {
        stickyPrice.innerHTML = html;
        stickyPrice.coatureSourceHtml = html;
      }
    }
  }

  var scheduled = false;
  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      watchPrimaryButton();
      sync();
    });
  }

  watchPrimaryButton();
  sync();

  if (productInfo && typeof MutationObserver !== 'undefined') {
    new MutationObserver(scheduleSync).observe(productInfo, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled'],
    });
  }

  document.addEventListener('click', function (event) {
    var stickyButton = event.target.closest('[data-coature-sticky-submit]');
    if (!stickyButton || stickyButton.hasAttribute('disabled')) return;
    stickyButton.classList.add('loading');
  });

  function clearLoading() {
    var stickyButton = currentBar().querySelector('[data-coature-sticky-submit]');
    if (stickyButton) stickyButton.classList.remove('loading');
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, clearLoading);
    subscribe(PUB_SUB_EVENTS.cartError, function () {
      clearLoading();
      // Dawn shows the cart error beside the primary button, which is off-screen when the
      // sticky bar was used — bring it into view so the message is actually seen.
      var button = primaryButton();
      if (button && !currentBar().hidden) button.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
})();
